import type { HealthConditionOption } from '@/types/registration';

export type AlignmentCondition = {
  code: string;
  display: string;
  onsetDateTime: string;
};

export const ECKM_CONDITION_MAP: Record<HealthConditionOption, Omit<AlignmentCondition, 'onsetDateTime'>> = {
  highBloodPressure: { code: 'I10', display: 'Essential (primary) hypertension' },
  highCholesterol: { code: 'E78.5', display: 'Hyperlipidemia, unspecified' },
  prediabetes: { code: 'R73.09', display: 'Other abnormal glucose' },
  overweightOrObesity: { code: 'E66.9', display: 'Obesity, unspecified' },
};

const onsetToday = (): string => new Date().toISOString().split('T')[0];

export function buildHypertensionOnlyConditions(): AlignmentCondition[] {
  return [{ ...ECKM_CONDITION_MAP.highBloodPressure, onsetDateTime: onsetToday() }];
}
